import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface DeleteContactParams {
  id: string
}

const deleteContact = async ({ id }: DeleteContactParams): Promise<void> => {
  await api.delete(`/contacts/${id}`)
}

export const useDeleteContact = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, DeleteContactParams>({
    mutationFn: deleteContact,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['contacts'] }),
        queryClient.invalidateQueries({ queryKey: ['contact'] }),
      ])
    },
  })
}

